import React from 'react';
import { Box, Grid, GridProps, Typography } from '@mui/material';
import { SparkTruncatedTypography } from 'sharedComponents/UI';
import PluginStepIcon from 'components/SVG/PluginStepIcon';
import KnowledgeIcon from 'components/SVG/KnowledgeIcon';
import { Star } from '@mui/icons-material';
import { Star00 } from 'components/SVG';

type TypeDetailCardProps = {
  icon: string;
  name: string;
  description: string;
  premium?: boolean;
  onClick?: () => void;
  dataID?: string;
  sx?: GridProps['sx'];
  isMemoryModal?: boolean;
};

function TypeDetailCard({
  icon,
  name,
  description,
  premium,
  onClick,
  sx,
  isMemoryModal = false,
}: TypeDetailCardProps) {
  return (
    <Grid
      container
      border={(theme) => `1px solid ${theme.palette.borderColor}`}
      alignItems='flex-start'
      borderRadius='10px'
      sx={{ cursor: 'pointer', flexWrap: 'nowrap', ...sx }}
      padding={1.5}
      gap={1}
      onClick={onClick}
    >
      <Grid item alignItems={'center'} display='flex' justifyContent='center'>
        {isMemoryModal ? (
          <KnowledgeIcon
            style={{ marginTop: '2px' }}
            width='42px'
            height='42px'
          />
        ) : icon ? (
          <Box
            src={icon}
            alt={name}
            component='img'
            sx={{
              height: '42px',
              width: '42px',
              borderRadius: '10px',
              marginTop: '2px',
            }}
          />
        ) : (
          <PluginStepIcon
            style={{ marginTop: '2px' }}
            width='42px'
            height='42px'
          />
        )}
      </Grid>
      <Grid item display='flex' flexDirection='column' width='100%'>
        <Box display={'flex'} justifyContent={'space-between'} width='100%'>
          <Grid>
            <SparkTruncatedTypography
              typographyProps={{
                variant: 'body1',
                fontFamily: 'Mont-SemiBold',
                sx: {
                  wordBreak: 'break-word',
                },
              }}
            >
              {name}
            </SparkTruncatedTypography>
            {description && (
              <Typography variant='body2'>{description}</Typography>
            )}
          </Grid>

          {premium && (
            <Grid
              item
              display='flex'
              alignItems='center'
              justifyContent='flex-start'
              width={'7rem'}
              height={'1.5rem'}
              bgcolor={(theme) => theme.palette.primary.main}
              border={(theme) => `1px solid ${theme.palette.primary.main}`}
              borderRadius={3}
              marginTop={1}
              paddingX={1}
            >
              <Star
                sx={{
                  fontSize: '1rem',
                  marginRight: 0.5,
                  color: (theme) => theme.palette.common.white,
                }}
              />{' '}
              <Typography
                variant='body2'
                color={(theme) => theme.palette.common.white}
                mt={0.2}
              >
                Premium
              </Typography>
            </Grid>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

export default TypeDetailCard;
